import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";

@Component({
    selector: "ifc-mfa-action-needed",
    templateUrl: "./mfa-action-needed.component.html",
    standalone: false
})
export class MfaActionNeededComponent {
  @ContentChild("description", { static: true, read: TemplateRef })
  descriptionRef: TemplateRef<unknown>;

  @Input()
  actionLabel: string;

  @Output()
  action = new EventEmitter<void>();

  onClickAction(): void {
    this.action.emit();
  }
}
